import { html } from "htm/preact/index.js";
import { useEffect, useMemo, useRef } from "preact/hooks";
import { useAppContext } from "src/services/context";

function DetailsFormTimer() {
    const state = useAppContext();

    const timer = state.pendingTimer.value;

        // Force a re-render every second.
        state.timerTick.value;

    const remainingMs = timer
        ? Math.max(0, timer.getTime() - Date.now())
        : 0;

    const totalSeconds = Math.floor(remainingMs / 1000);

    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    const visualTime = `${minutes}:${String(seconds).padStart(2, "0")}`;

    const lastMinuteAnnounced = useRef(null);

    const spokenTime = useMemo(() => {
        if (minutes === 0 && seconds === 0) {
            return "Reservation timer expired";
        }

        if (minutes > 0) {
            return `${minutes} minute${minutes === 1 ? "" : "s"} remaining to complete your reservation`;
        }

        return "Less than one minute remaining to complete your reservation";
    }, [minutes]);

    useEffect(() => {
        if (!timer) {
            lastMinuteAnnounced.current = null;
            return;
        }

        let message = "";

        // Announce each minute once, regardless of whether the timer
        // lands exactly on xx:00.
        if (
            minutes > 0 &&
            minutes !== lastMinuteAnnounced.current
        ) {
            lastMinuteAnnounced.current = minutes;

            message = `${minutes} minute${minutes === 1 ? "" : "s"} remaining to complete your reservation.`;
        } else if (minutes === 0 && seconds === 30) {
            message = "30 seconds remaining to complete your reservation.";
        } else if (minutes === 0 && seconds <= 10 && seconds > 0) {
            message = `${seconds} second${seconds === 1 ? "" : "s"} remaining to complete your reservation.`;
        } else if (minutes === 0 && seconds === 0) {
            message =
                "Your reservation hold has expired. You can still try to complete your reservation, but this table may no longer be available.";
        }

        if (!message) {
            return;
        }

        console.log("ANNOUNCE:", message);

        state.liveAnnouncement.value = "";

        const timeout = setTimeout(() => {
            state.liveAnnouncement.value = message;
        }, 100);

        return () => clearTimeout(timeout);

    }, [timer, minutes, seconds]);

    return html`
        <span
            id="reservation-timer"
            class="mx-details__timer"
            role="timer"
            aria-live="off"
        >
            <span aria-hidden="true">
                ${visualTime}
            </span>

            <span class="sr-only">
                ${spokenTime}
            </span>
        </span>
    `;
}

export default DetailsFormTimer;